export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const HOMEPAGE_URL = process.env.REACT_APP_HOMEPAGE_URL;

export default {};